module.exports = __webpack_public_path__ + "static/media/favicon.2769ead6.ico";